import { MODULE_NAME } from './constants';
import cmsReducer from './reducer';
import { createReduxModule } from '../../utils/reduxUtils';

export * from './actions';
export * from './types';

export default createReduxModule(MODULE_NAME, cmsReducer);
